<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="chapter-title">
      Сведения о производстве строительно-монтажных работ с учетом
      результатов операционного контроля их качества
    </div>
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="$app.auth.can('journals_main_records', project.id)" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">Дата производства работ и смена</td>
          <td rowspan="2">Краткое описание строительно-монтажных работ, их месторасположение</td>
          <td rowspan="2">Состояние погоды и температура наружного воздуха</td>
          <td rowspan="2">Принимаемые меры в особых условиях (зимний период, жара и т.д.)</td>
          <td colspan="2">Приемка выполненных строительно-монтажных работ</td>
          <td rowspan="2">Результаты операционного контроля качества работ</td>
          <td rowspan="2">Должность, фамилия, инициалы и подписи ответственного лица и лица, оценивающего качество работ</td>
          <td rowspan="2">Статус</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>Ед. измер.</td>
          <td>Количество</td>
        </tr>
      </template>
      <template #publishedAt="{item}">
        {{ $app.date.format(item.publishedAt) }}
      </template>
      <template #users="{item}">
        <c-journal-sign :sign="getSign(item, 'author')" />
        <c-journal-sign :sign="getSign(item, 'approver')" />
      </template>
      <template #status="{item}">
        {{ utils.status(item.status) }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>
    
    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />

  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from '../../../components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { CJournalSign, ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    columns() {
      return [
        { name: 'publishedAt', title: '', },
        { name: 'description', title: '', },
        { name: 'weather', title: '', },
        { name: 'solution', title: '', },
        { name: 'work.0.unit', title: '', },
        { name: 'work.0.recordDone', title: '', },
        { name: 'results', title: '', },
        { name: 'users', title: '', },
        { name: 'status', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'main')
        .query({
          'with[signs][with][author]': null,
          'with[work]': null,
          projectId: this.project.id,
        }).all()
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
